import { ref, onMounted } from 'vue';
import { useScroll } from '@vueuse/core';

function scrollToTop() {
  const scrollForm = document.querySelector('.scrollToTop') as HTMLElement | null;
  const scrollModal = document.querySelector('.scrollToTopModal') as HTMLElement | null;

  if (scrollForm) {
    const { y: yForm } = useScroll(scrollForm);
    yForm.value = 0;
  }

  if (scrollModal) {
    const { y: yModal } = useScroll(scrollModal);
    yModal.value = 0;
  }
}

function addPaddingOnScroll(refElement: any) {
  const isScrollable = ref(false);

  onMounted(() => {
    const resizeObserver = new ResizeObserver(() => {
      if (!refElement.value) return (isScrollable.value = false);

      isScrollable.value = refElement.value.scrollHeight > refElement.value.clientHeight;
    });

    if (refElement.value) resizeObserver.observe(refElement.value);
  });

  return { isScrollable };
}

export { addPaddingOnScroll, scrollToTop };
